import moment from 'moment';

export const cashbookColumns = [
  { key: 'approved', label: 'Approved', width: 110, excelWidth: 15 },
  { key: 'created', label: 'Created', width: 110, excelWidth: 15 },
  { key: 'voucher_id', label: 'Voucher ID', width: 130, excelWidth: 19 },
  { key: 'particular', label: 'Particular', width: 220, excelWidth: 32 },
  { key: 'issuer_type', label: 'Issuer Type', width: 155, excelWidth: 23 },
  { key: 'outward', label: 'Outward', width: 140, excelWidth: 20, money: true },
  { key: 'inward', label: 'Inward', width: 140, excelWidth: 20, money: true },
  { key: 'balance', label: 'Balance', width: 150, excelWidth: 22, money: true },
  { key: 'remarks', label: 'Remark', width: 240, excelWidth: 36 },
];

export const cashbookAmounts = entry => {
  const type = String(entry?.expenseType || '').trim().toLowerCase();
  const amount = Number(Number(entry?.amount || 0).toFixed(2));
  return { outward: type === 'outward' ? amount : null, inward: type === 'inward' ? amount : null };
};

export const cashbookExportRow = entry => {
  const amounts = cashbookAmounts(entry);
  return [
    entry?.approvedOn ? moment(entry.approvedOn).format('DD/MM/YYYY') : '',
    entry?.createDate ? moment(entry.createDate).format('DD/MM/YYYY') : '',
    entry?.voucherNumber || '', entry?.name || '', entry?.vendorType || '',
    amounts.outward ?? '', amounts.inward ?? '', Number(Number(entry?.siteBalance || 0).toFixed(2)), entry?.remarks || '',
  ];
};
